/* TEWIKY PDP UGC — no cart bindings or third-party player dependency. */
(function(){
  if(!window.customElements||customElements.get('twk-pdp-video-gallery'))return;
  customElements.define('twk-pdp-video-gallery',class extends HTMLElement{
    connectedCallback(){this.initFrame=requestAnimationFrame(()=>this.initialize());}
    disconnectedCallback(){
      cancelAnimationFrame(this.initFrame);cancelAnimationFrame(this.railFrame);
      this.closeVideo();
      if(this.listeners)this.listeners.abort();
      if(this.observer)this.observer.disconnect();
      this.ready=false;this.railFrame=0;
    }
    initialize(){
      if(!this.isConnected||this.ready)return;
      this.track=this.querySelector('[data-twk-video-track]');
      this.dialog=this.querySelector('dialog');
      this.templates=Array.from(this.querySelectorAll('[data-twk-video-template]'));
      if(!this.track||!this.dialog||!this.templates.length)return;
      this.ready=true;this.index=0;
      this.host=this.querySelector('[data-twk-video-host]');
      this.counter=this.querySelector('[data-twk-video-count]');
      this.status=this.querySelector('[data-twk-video-status]');
      this.previous=this.querySelector('[data-twk-video-prev]');
      this.next=this.querySelector('[data-twk-video-next]');
      this.railNav=this.querySelector('[data-twk-video-rail-nav]');
      this.railPrev=this.querySelector('[data-twk-video-rail-prev]');
      this.railNext=this.querySelector('[data-twk-video-rail-next]');
      this.listeners=new AbortController();
      const on=(target,event,fn,options={})=>target.addEventListener(event,fn,{...options,signal:this.listeners.signal});
      on(this,'click',event=>{
        const button=event.target.closest('[data-twk-video-open]');
        if(button&&this.contains(button))this.openVideo(Number(button.dataset.twkVideoOpen),button);
      });
      on(this.querySelector('[data-twk-video-close]'),'click',()=>this.closeVideo());
      on(this.previous,'click',()=>this.playItem(this.index-1));
      on(this.next,'click',()=>this.playItem(this.index+1));
      on(this.dialog,'cancel',event=>{event.preventDefault();this.closeVideo();});
      on(this.dialog,'close',()=>{if(!this.dialog.open)this.releasePlayer();});
      on(this.dialog,'click',event=>{
        if(event.target!==this.dialog)return;
        const rect=this.dialog.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.closeVideo();
      });
      on(this.dialog,'keydown',event=>{
        // The native video's arrow keys continue to control seeking / volume.
        if(event.target.closest('video'))return;
        if(event.key==='ArrowLeft'){event.preventDefault();this.playItem(this.index-1);}
        else if(event.key==='ArrowRight'){event.preventDefault();this.playItem(this.index+1);}
      });
      on(this.railPrev,'click',()=>this.scrollRail(-1));
      on(this.railNext,'click',()=>this.scrollRail(1));
      const schedule=()=>{if(!this.railFrame)this.railFrame=requestAnimationFrame(()=>{this.railFrame=0;this.updateRail();});};
      on(this.track,'scroll',schedule,{passive:true});
      if(window.ResizeObserver){this.observer=new ResizeObserver(schedule);this.observer.observe(this.track);}
      else on(window,'resize',schedule);
      this.updateRail();
    }
    updateRail(){
      const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      const position=Math.abs(this.track.scrollLeft);
      this.railNav.hidden=max<=2;this.railPrev.disabled=position<=2;this.railNext.disabled=position>=max-2;
    }
    scrollRail(direction){
      const card=this.track.querySelector('[data-twk-video-open]');
      if(!card)return;
      const gap=parseFloat(getComputedStyle(this.track).columnGap)||8;
      const width=card.getBoundingClientRect().width+gap;
      const steps=Math.max(1,Math.floor(this.track.clientWidth/width)-1);
      const rtl=getComputedStyle(this.track).direction==='rtl'?-1:1;
      this.track.scrollBy({left:direction*rtl*width*steps,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    openVideo(index,trigger){
      if(!this.templates[index])return;
      this.trigger=trigger;
      if(!this.dialog.open){
        this.dialog.showModal();
        this.scrollStyles=[document.documentElement,document.body].map(element=>({element,value:element.style.getPropertyValue('overflow'),priority:element.style.getPropertyPriority('overflow')}));
        this.scrollStyles.forEach(({element})=>element.style.setProperty('overflow','hidden'));
      }
      this.playItem(index);
    }
    playItem(index){
      if(!this.dialog.open||!this.templates[index])return;
      if(this.video){this.volume=this.video.volume;this.muted=this.video.muted;}
      this.unloadVideo();this.index=index;this.status.hidden=true;
      this.host.appendChild(this.templates[index].content.cloneNode(true));
      const video=this.host.querySelector('video');this.video=video;
      this.counter.textContent=(index+1)+' / '+this.templates.length;
      this.previous.disabled=index===0;this.next.disabled=index===this.templates.length-1;
      if(!video){this.message('This video is unavailable. Please try another clip.');return;}
      video.controls=true;video.playsInline=true;video.preload='metadata';
      video.volume=this.volume===undefined?1:this.volume;video.muted=this.muted===undefined?false:this.muted;
      video.addEventListener('error',()=>{if(this.video===video)this.message('This video is unavailable. Please try another clip.');},{once:true});
      video.addEventListener('playing',()=>{if(this.video===video)this.status.hidden=true;});
      const playback=video.play();
      if(playback&&playback.catch)playback.catch(error=>{
        if(this.video!==video||!this.dialog.open||error.name==='AbortError')return;
        this.message(error.name==='NotAllowedError'?'Tap play to watch this video.':'Unable to play this video. Please try again or choose another clip.');
      });
    }
    message(text){this.status.textContent=text;this.status.hidden=false;}
    unloadVideo(){
      if(this.video){
        const video=this.video;this.video=null;
        video.pause();video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source=>source.removeAttribute('src'));
        video.load();
      }
      if(this.host)this.host.replaceChildren();
    }
    releasePlayer(){
      this.unloadVideo();
      if(this.scrollStyles){
        this.scrollStyles.forEach(({element,value,priority})=>{
          if(element.style.getPropertyValue('overflow')!=='hidden')return;
          if(value)element.style.setProperty('overflow',value,priority);else element.style.removeProperty('overflow');
        });
        this.scrollStyles=null;
      }
      if(this.trigger&&this.trigger.isConnected)this.trigger.focus({preventScroll:true});
      this.trigger=null;
    }
    closeVideo(){if(this.dialog&&this.dialog.open)this.dialog.close();this.releasePlayer();}
  });
})();
